import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EXTERNAL_REQUEST_HEADER } from 'core-app/features/hal/http/openproject-header-interceptor';

export class ApiKeyInterceptor implements HttpInterceptor {
  apiKey():string|undefined {
    return jQuery('meta[name=openproject_api_key]').attr('content');
  }

  intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>> {
    let apiKey = this.apiKey();

    if (apiKey) {
      let newHeaders = req.headers
        .set(EXTERNAL_REQUEST_HEADER, 'true')
        .set('X-Authentication-Scheme', 'Basic')
        .set('Authorization', `Basic ${btoa(`apikey:${apiKey}`)}`)

      const clonedRequest = req.clone({
        withCredentials: true,
        headers: newHeaders,
      });

      return next.handle(clonedRequest);
    } else {
      return next.handle(req);
    }
  }
}
